export { default as contactUsFormBg } from './contact-for-bg.svg';
export { default as greenSquareIcon } from './greenSquare.svg';
export { default as careerBgSvg } from './careerBgSvg.svg';
export { default as futureBgSvg } from './futureBgSvg.svg';
export const careerImage = require('./careerImage.jpg?webp');
export const careerImage2x = require('./careerImage-2x.jpg?webp');
export const futuresImage = require('./futuresImage.jpg?webp');
export const futuresImage2x = require('./futuresImage-2x.jpg?webp');
export const reliableSolutionsImage = require('./reliableSolutions.png?webp');
export const reliableSolutionsImage2x = require('./reliableSolutions-2x.png?webp');
export const ContactUsBlock1 = require('./ContactUsBlock.jpg?webp');
export const buc2x = require('./map/buc-2x.jpg?webp');
export const buc = require('./map/buc.jpg?webp');
export const gurugram2x = require('./map/gurugram-2x.png');
export const gurugram = require('./map/gurugram.png');
export const kiv2x = require('./map/kiv-2x.jpg?webp');
export const kiv = require('./map/kiv.jpg?webp');
export const chi2x = require('./map/chi-2x.jpg?webp');
export const chi = require('./map/chi.jpg?webp');
export const phi2x = require('./map/phi-2x.jpg?webp');
export const phi = require('./map/phi.jpg?webp');
export const nj2x = require('./map/nj-2x.png?webp');
export const nj = require('./map/nj.png?webp');
export const bucharest = require('./map/bucharest.png?webp');
